import script from "./teams.vue?vue&type=script&setup=true&lang=js"
export * from "./teams.vue?vue&type=script&setup=true&lang=js"

import "./teams.vue?vue&type=style&index=0&id=51174a38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.21_vue@3.5.21_webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51174a38"]])

export default __exports__